import { graphql } from "react-relay";

export const GET_S3_VIDEO_DATA_MUTATION = graphql`
	mutation s3VideoSourceField_GetS3VideoDataV2Mutation($input: GetS3VideoDataV2Input!) {
		Admin {
			ElearningV2 {
				getS3VideoData(input: $input) {
					s3VideoData {
						videoKey
						sizeInBytes
						contentType
						subtitleLanguages
						invalidSubtitles {
							language
							invalidLine
							keepsPublishedVersion
						}
						playbackUrl
					}
				}
			}
		}
	}
`;
